import * as http from '../../modules/http';
import * as UrlParamsManager from '../../modules/UrlParamsManager';

export const SALES_STATS_REQUEST_START = 'SALES_STATS_REQUEST_START';
export const SALES_STATS_REQUEST_SUCCESS = 'SALES_STATS_REQUEST_SUCCESS';
export const SALES_STATS_REQUEST_FAILED = 'SALES_STATS_REQUEST_FAILED';
export const SALES_STATS_REQUEST_NO_PERMISSION = 'SALES_STATS_REQUEST_NO_PERMISSION';
export const SALES_STATS_OPEN_UPDATE_FORM = 'SALES_STATS_OPEN_UPDATE_FORM';
export const SALES_STATS_DELETE = 'SALES_STATS_DELETE';
export const SALES_STATS_UPDATE = 'SALES_STATS_UPDATE';

export function sales_stats_request_start(date) {
    return {
        type: SALES_STATS_REQUEST_START,
        date:date
    };
}

export function sales_stats_request_success(data) {
    return {
        type: SALES_STATS_REQUEST_SUCCESS,
        data:data
    };
}

export function sales_stats_request_failed() {
    return {
        type: SALES_STATS_REQUEST_FAILED
    };
}

export function sales_stats_request_no_permission() {
    return {
        type: SALES_STATS_REQUEST_NO_PERMISSION
    };
}

export function sales_stats_open_update_form(customer) {
    return {
        type: SALES_STATS_OPEN_UPDATE_FORM,
        customer:customer
    };
}

export function sales_stats_delete(id) {
    return {
        type: SALES_STATS_DELETE,
        id:id
    };
}

//
//
//Async Actions
//
//
export function fetchSalesStatsDataIfNeeded(queryParams) {
    var date = UrlParamsManager.getDate(queryParams, 'last_month');
    //var managers = UrlParamsManager.getManagers(queryParams);

    return (dispatch, getState) => {
        if (shouldFetchSalesStatsData(getState(),date/*,managers*/)) {
            return dispatch(fetchSalesStatsData(date/*,managers*/));
        }
    };
}

function shouldFetchSalesStatsData(state,date/*,managers*/) {
    if (!state.salesStats.data){
        return true;
    }
    else if (state.salesStats.date !== date /*||*/
        /*state.salesStats.managers !== managers*/) {
        return true;
    }
    else{
        return false;
    }
}


function fetchSalesStatsData(date/*,managers*/) {
    var dateFilter = {
        filter:true,
        platform:'',
        value:date.date,
        range:{startDate:date.startDate,endDate:date.startDate}
    };

    var requestParams = {
        date:dateFilter,
        //managers:managers
    };

    return ((dispatch) => {
        dispatch(sales_stats_request_start(date));

        let request = 'sales_stats/get';

        http.postToServer(request,
            requestParams,
            (response) =>  {dispatch(sales_stats_request_success(response.data))},
            (response) =>  {dispatch(sales_stats_request_failed())},
            (response) =>  {dispatch(sales_stats_request_no_permission())}

        );

    });
}
